var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarliestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66675C14.6023 1.66675 18.3332 5.39758 18.3332 10.0001C18.3332 14.6026 14.6023 18.3334 9.99984 18.3334C5.39734 18.3334 1.6665 14.6026 1.6665 10.0001C1.6665 5.39758 5.39734 1.66675 9.99984 1.66675ZM9.99984 5.00008C9.77882 5.00008 9.56686 5.08788 9.41058 5.24416C9.2543 5.40044 9.1665 5.6124 9.1665 5.83341V10.0001C9.16655 10.2211 9.25438 10.433 9.41067 10.5892L11.9107 13.0892C12.0678 13.241 12.2783 13.325 12.4968 13.3231C12.7153 13.3212 12.9243 13.2336 13.0789 13.0791C13.2334 12.9246 13.321 12.7156 13.3229 12.4971C13.3248 12.2786 13.2408 12.0681 13.089 11.9109L10.8332 9.65508V5.83341C10.8332 5.6124 10.7454 5.40044 10.5891 5.24416C10.4328 5.08788 10.2209 5.00008 9.99984 5.00008Z",
    fill: "#0D99FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarliestIcon);
export default __webpack_public_path__ + "static/media/earliest-icon.fb339b7bf0436ae3d0783e7e2d48968b.svg";
export { ForwardRef as ReactComponent };